export default "__VITE_ASSET__DBPkShq3__"